import React, { FC, useState } from 'react';
import { useFormik } from 'formik';
import {
	FORM_FIELDS, FORM_FIELDS_NAMES,
	initialValues,
	IUserDetails,
	ROLE,
	ROLES,
	userMerchantDetailsSchema,
	userSuperAdminDetailsSchema,
} from '../../constants/users/userModalUtils';
import { FormInput } from '../merchants/FormInput';
import { RadioInput } from '../common/RadioInput';
import { USER_INFORMATION } from '../../constants/users/user-information';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { useIdentity } from '../../store/identyti/identity-context';
import { setUser } from '../../store/identyti/actions/users';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';
import { Input } from '../developers/page-components/Input';

interface Props {
	onCancel: () => void;
	onSuccess: () => void;
	onError: () => void;
}

export const UserModalContent: FC<Props> = (props): JSX.Element => {
	const { onCancel, onSuccess, onError } = props;
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const isAdmin = checkRoles(authUser, CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN);
	const [userRole, setUserRole] = useState<string>(ROLE.MERCHANT_ADMIN);
	const { identityState: { isNewUserLoading }, dispatch } = useIdentity();
	const { merchantState: { listOfMerchants: merchantList }} = useMerchants();
	const formik = useFormik<IUserDetails>({
		initialValues,
		validationSchema: isAdmin ? userSuperAdminDetailsSchema : userMerchantDetailsSchema,
		onSubmit: () => setUser(dispatch, formik, onSuccess, onError, userRole, isAdmin)
	});

	const emailAdditionalClasses = 'col-sm-12 col-md-12';

	const additionalClasses = 'col-12 col-sm-12 col-md-12';

	const searchBy = (keyword, label, item): boolean => {
		return String(item.label).toLowerCase().trim().includes(keyword.toLowerCase().trim())
			|| String(item.value).toLowerCase().trim().includes(keyword.toLowerCase().trim())
			|| String(item?.companyName).toLowerCase().trim().includes(keyword.toLowerCase().trim());
	};

	const renderMenuItem=(label, item): JSX.Element => {
		return (
			<div>
				<div>{label}</div>
				{item?.companyName && <div className="fs-8">({item?.companyName})</div>}
			</div>
		);
	};

	const INPUTS = USER_INFORMATION({ isDisabled: false, emailAdditionalClasses, additionalClasses, merchantList, searchBy, renderMenuItem });

	const fields = isAdmin
		? INPUTS
		: INPUTS.filter(input => input.key !== FORM_FIELDS.MERCHANT_ID);


	return (
		<>
			<form onSubmit={formik.handleSubmit} noValidate className="form w-100 add-user-modal">
				<div className="px-15 w-100">
					{
						fields?.map(item => (
							<FormInput
								{...item}
								formik={formik}
								key={item.key}
							/>
						))
					}
					<div className="my-10">
						<Input
							formik={formik}
							fieldLabel={FORM_FIELDS_NAMES.IS_MASKED_PII}
							checkboxFieldName={FORM_FIELDS.IS_MASKED_PII}
							inputType="checkbox"
							additionalClass="cursor-pointer"
						/>
					</div>


					<div className="d-flex flex-column align-items-start justify-content-start">
						<div className="fs-5">
							Role
						</div>
						<div className="d-flex flex-column align-items-start justify-content-start">
							{
								ROLES?.map((role, index) => (
									<RadioInput key={`role-${index}`} {...role} currentValue={userRole} setCurrentValue={setUserRole}/>
								))
							}
						</div>
					</div>


				</div>
				<div className="w-100 d-flex justify-content-center align-items-center px-7 py-5">
					<ButtonComponent
						buttonName="Cancel"
						buttonType={BUTTON_TYPE.CANCELLED}
						onButtonClick={onCancel}
						additionalClass="me-10"
					/>

					<ButtonComponent
						buttonName="Confirm"
						type="submit"
						loading={isNewUserLoading}
						additionalClass="w-115px"
						isDisabled={isNewUserLoading}
					/>
				</div>
			</form>
		</>

	);
};
